// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1vF3y","author":"Table_author__W-FMi","authorImage":"Table_authorImage__GklkJ","unreadRow":"Table_unreadRow__26pqA"};